import React from "react";
//project components
import ProjectsHtmlCss from "./ProjectsHtmlCss";
import ProjectJs from "./ProjectJs";
import ProjectReact from "./ProjectReact";
import ProjectDjango from "./ProjectDjango";
//material ui
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
//style
import useStyles from "./styles";

// const background = [chatbot, ecommerce,tasks, me, expense, mail];

const Projects = () => {
  const classes = useStyles();

  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
        <h2 className={classes.title}><u>CHECK OUT SOME OF MY PROJECTS</u></h2>
          <Box sx={{ borderBottom: 1, borderColor: "divider", display: "flex", justifyContent:"center" }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab sx={{ backgroundColor: "#222831", color:"white", padding:"20px", width:"20rem", marginRight:"20px", marginBottom:"5px", borderRadius:"10px", fontSize:"20px" }} label="HTML / CSS" value="1" />
              <Tab sx={{ backgroundColor: "#222831", color:"white", padding:"20px", width:"20rem", marginRight:"20px", marginBottom:"5px", borderRadius:"10px", fontSize:"20px" }} label="jS / HTML / CSS" value="2"/>
              <Tab sx={{ backgroundColor: "#222831", color:"white", padding:"20px", width:"20rem", marginRight:"20px", marginBottom:"5px", borderRadius:"10px", fontSize:"20px" }} label="REACT" value="3"/>
              <Tab sx={{ backgroundColor: "#222831", color:"white", padding:"20px", width:"20rem", marginRight:"20px", marginBottom:"5px", borderRadius:"10px", fontSize:"20px" }} label="DJANGO" value="4"/>
            </TabList>
          </Box>
          <TabPanel value="1"><ProjectsHtmlCss/> </TabPanel>
          <TabPanel value="2"><ProjectJs/></TabPanel>
          <TabPanel value="3"><ProjectReact/></TabPanel>
          <TabPanel value="4"><ProjectDjango/></TabPanel>
          <h5 className={classes.checkTitle}><a href="https://github.com/enes9103">You can check out my all projects</a></h5>
        </TabContext>
      </Box>

  );
}

export default Projects;